import { useHasScope } from '~hooks/permissions/use-has-scope'
import {
  allPartnersOnboardedEnabled,
  getFeatureToggle,
} from '~utils/feature-toggles'

export function useShowLimitedExperience() {
  const dpp = useHasScope(
    'pool:Aframax:partner',
    'pool:Suezmax:partner',
    'pool:Panamax:partner',
  )

  const cpp = useHasScope(
    'pool:City:partner',
    'pool:Chemicals 1:partner',
    'pool:Chemicals 2:partner',
    'pool:Chemicals 3:partner',
    'pool:Chemicals 4:partner',
    'pool:Handy:partner',
    'pool:Intermediate:partner',
    'pool:MR:partner',
    'pool:LR1:partner',
    'pool:LR2:partner',
  )

  return !getFeatureToggle(allPartnersOnboardedEnabled) && dpp && !cpp
}
